import {
  actions,
} from '../reducer';

import {
  getOrganizations,
} from './api.service';

const {
  getOrganizationsRequest,
  getOrganizationsSuccess,
  getOrganizationsFailure,
  setOrganizationId,
} = actions;

export const fetchOrganizationsForSelect = () => async (dispatch, getState) => {
  const { initiativeId } = getState().globalSelections;
  try {
    dispatch(getOrganizationsRequest());
    const { data } = await getOrganizations({
      perPage: 999,
      page: 1,
      initiative_id: initiativeId,
    });
    dispatch(getOrganizationsSuccess({ organizations: data.data }));
  } catch ({ message }) {
    dispatch(getOrganizationsFailure(message));
  }
};

export const setOrganization = (organizationId) => async (dispatch) => {
  try {
    sessionStorage.setItem('organization_id', organizationId);
    dispatch(setOrganizationId({ organizationId }));
  } catch ({ message }) {
    console.log(message);
  }
};
